export default "__VITE_ASSET__D3kDbHNg__"